/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Checkbox from './Checkbox.vue';

/**
 * Base component to wrap togglers with a common markup.
 *
 * It has all `Checkbox` options.
 *
 * @example
 *
 * toggler(:label="t('switch')" :errs="errors" v-model="form.active" name="active")
 *
 * @category ui.components.form-elements
 * @exports Toggler
 * @component
 */
const __vue_script__ = {
    name: 'Toggler',

    extends: Checkbox,

    props: {
        onLabel: {
            type: String,
            default: 'general.on'
        },

        offLabel: {
            type: String,
            default: 'general.off'
        },

        labelAfterWidget: {
            type: Boolean,
            default: true
        },

        inverted: {
            type: Boolean,
            default: false
        },

        inlineTip: {
            type: String,
            default: ''
        },

        inlineHint: {
            type: String,
            default: ''
        },

        inlineLabel: {
            type: Boolean,
            default: false
        },

        hintWithHtml: {
            type: String,
            default: ''
        }
    },

    computed: {
        togglerLabel() {
            const onLabel = this.inverted ? this.offLabel : this.onLabel;
            const offLabel = this.inverted ? this.onLabel : this.offLabel;

            let labelKey = this.value ? onLabel : offLabel;
            if (this.inlineLabel) {
                labelKey = this.label;
            }

            return this.$te(labelKey) ? this.$t(labelKey) : labelKey;
        }
    },

    methods: {
        /** @param {InputEvent} $event */
        onChange($event) {
            const val = this.inverted ? !$event.target.checked : $event.target.checked;
            return this.$emit('input', val);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('control-decorator',{attrs:{"label":_vm.inlineLabel ? null: _vm.label,"tip":(!_vm.label || _vm.inlineLabel) ? null : _vm.tip,"hint":_vm.hint,"hint-after-label":_vm.hintAfterLabel,"uid":_vm.uid,"errors":_vm.errors,"warning":_vm.warning,"dependant":_vm.dependant},scopedSlots:_vm._u([{key:"label",fn:function(ref){return [_vm._t("label")]}},{key:"hint",fn:function(){return [_vm._t("hint")]},proxy:true},{key:"after-label",fn:function(ref){return [_c('label',{staticClass:"toggler",class:{'has-error': _vm.errors.length, disabled: _vm.disabled, 'inline-tooltip': !!_vm.inlineTip}},[(!_vm.labelAfterWidget)?[_vm._v(_vm._s(_vm.togglerLabel)),((!_vm.label || _vm.inlineLabel) && _vm.tip)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tip),expression:"tip"}],staticClass:"tip ic-info-fill"}):_vm._e()]:_vm._e(),_c('span',[_c('input',{ref:"input",attrs:{"id":_vm.uid,"type":"checkbox","name":_vm.name,"disabled":_vm.disabled},domProps:{"checked":(_vm.inverted ? !_vm.value : _vm.value)},on:{"change":_vm.onChange}}),_c('span',{staticClass:"switch"})]),(_vm.labelAfterWidget && !_vm.inlineTip)?[_vm._v(_vm._s(_vm.togglerLabel)),((!_vm.label || _vm.inlineLabel) && _vm.tip)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tip),expression:"tip"}],staticClass:"tip ic-info-fill"}):_vm._e()]:_vm._e(),(_vm.inlineHint)?[_c('div',{staticClass:"inline-hint"},[_vm._v(_vm._s(_vm.inlineHint))])]:_vm._e(),(!!_vm.inlineTip)?[_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.inlineTip),expression:"inlineTip"}]},[_c('p',[_vm._v(_vm._s(_vm.togglerLabel))]),_c('i',{staticClass:"tip ic-info-fill"})])]:_vm._e(),(_vm.hintWithHtml)?[_c('div',{staticClass:"inline-hint",domProps:{"innerHTML":_vm._s(_vm.hintWithHtml)}})]:_vm._e()],2)]}}],null,true)},[_vm._t("default")],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Toggler.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__